import React from "react";
import { AttributeCriterion } from "../../types";

type Props = {
  value: AttributeCriterion;
  handleInputChange: (event: {
    target: {
      name: string;
      value: string;
    };
  }) => void;
  acceptedValues?: string[];
};

export const SelectDisplayValues: React.FC<Props> = ({ value, handleInputChange, acceptedValues }) => {
  return (
    <div className="select is-fullwidth">
      <select name="value" value={value.value} onChange={handleInputChange} className="is-text-overflow">
        {!value.value && (
          <option value="" defaultValue="">
            ---
          </option>
        )}
        {acceptedValues ? (
          acceptedValues?.map((value, index) => (
            <option key={index} value={value}>
              {value}
            </option>
          ))
        ) : (
          <option value="-">No value</option>
        )}
      </select>
    </div>
  );
};
